// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"9b74438d","118":"5ea21d69","313":"7f532404","465":"d451fcd8","836":"423813df","959":"d1aab4cc"}[chunkId] + ".chunk.js";
};